// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles for VerifiedBadge component
 */

.verified-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s;
}

/* Size variants */
.verified-badge--small {
  font-size: 11px;
  padding: 2px 6px;
}

.verified-badge--medium {
  font-size: 12px;
  padding: 4px 8px;
}

.verified-badge--large {
  font-size: 14px;
  padding: 6px 12px;
}

/* Verified state */
.verified-badge--verified {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.verified-badge--verified .verified-badge__icon {
  color: #28a745;
}

/* Unverified state */
.verified-badge--unverified {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.verified-badge--unverified .verified-badge__icon {
  font-size: 0.9em;
}

/* Verifying state */
.verified-badge--verifying {
  background-color: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.verified-badge--verifying .verified-badge__icon {
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Icon */
.verified-badge__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Text */
.verified-badge__text {
  display: inline-block;
}

/* Dark theme */
@media (prefers-color-scheme: dark) {
  .verified-badge--verified {
    background-color: #1e3a2a;
    color: #6ee7b7;
    border-color: #10b981;
  }

  .verified-badge--verified .verified-badge__icon {
    color: #10b981;
  }

  .verified-badge--unverified {
    background-color: #3a2f1a;
    color: #fbbf24;
    border-color: #f59e0b;
  }

  .verified-badge--verifying {
    background-color: #1a2f3a;
    color: #60a5fa;
    border-color: #3b82f6;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/devices/VerifiedBadge.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,SAAS;AACT;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,SAAS;AACT;EACE,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;EACvB;AACF","sourcesContent":["/**\n * Styles for VerifiedBadge component\n */\n\n.verified-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  transition: all 0.2s;\n}\n\n/* Size variants */\n.verified-badge--small {\n  font-size: 11px;\n  padding: 2px 6px;\n}\n\n.verified-badge--medium {\n  font-size: 12px;\n  padding: 4px 8px;\n}\n\n.verified-badge--large {\n  font-size: 14px;\n  padding: 6px 12px;\n}\n\n/* Verified state */\n.verified-badge--verified {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.verified-badge--verified .verified-badge__icon {\n  color: #28a745;\n}\n\n/* Unverified state */\n.verified-badge--unverified {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeaa7;\n}\n\n.verified-badge--unverified .verified-badge__icon {\n  font-size: 0.9em;\n}\n\n/* Verifying state */\n.verified-badge--verifying {\n  background-color: #d1ecf1;\n  color: #0c5460;\n  border: 1px solid #bee5eb;\n}\n\n.verified-badge--verifying .verified-badge__icon {\n  animation: rotate 2s linear infinite;\n}\n\n@keyframes rotate {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Icon */\n.verified-badge__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Text */\n.verified-badge__text {\n  display: inline-block;\n}\n\n/* Dark theme */\n@media (prefers-color-scheme: dark) {\n  .verified-badge--verified {\n    background-color: #1e3a2a;\n    color: #6ee7b7;\n    border-color: #10b981;\n  }\n\n  .verified-badge--verified .verified-badge__icon {\n    color: #10b981;\n  }\n\n  .verified-badge--unverified {\n    background-color: #3a2f1a;\n    color: #fbbf24;\n    border-color: #f59e0b;\n  }\n\n  .verified-badge--verifying {\n    background-color: #1a2f3a;\n    color: #60a5fa;\n    border-color: #3b82f6;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
